import { useState } from "react";
import { Get, Set } from "../../../../../Request";
import { useSelector } from "react-redux";
import { amdinManagerClassManagerCombine } from "../../../../../Utils/orderListRoutes";
import { useLocation } from "react-router-dom";
export const useOrderList = role => {
  const loc = useLocation();
  const { user } = useSelector(state => state);
  const [loading, setLoading] = useState({
    list: true,
  });
  const [data, setData] = useState({});
  const [data2, setData2] = useState({});
  const [filter, setFilter] = useState({});
  const [showModal, setShowModal] = useState({
    status: false,
    name: "",
  });
  const getData = async (data, filters) => {
    setLoading({ ...loading, list: true });
    const res1 = await Get({ url: "/itemfinancial/show", data: { ...data, app: loc.pathname == "/panel/GeneralOrders" && true } });
    setData(res1);
    const res2 = await Get({ url: "/itemfinancial/user_list", data: { ...data, ...filters, app: loc.pathname == "/panel/GeneralOrders" && true } });
    setData2(res2);

    setLoading({ ...loading, list: false });
  };
  const searchHandler = search => {
    setFilter({ ...filter, search });
    getData({ search });
  };
  const pageHandler = (page, limit = 15) => {
    getData({ ...filter, page, limit });
  };
  const sortHandler = (key, value) => {
    setFilter({ ...filter, [key]: value });
    getData({ ...filter, [key]: value });
  };
  return {
    loading,
    getData,
    data,
    data2,
    showModal,
    setShowModal,
    searchHandler,
    pageHandler,
    setFilter,
    sortHandler,
    filter,
    setFilter
  };
};
